import * as React from 'react';
import classnames from 'classnames';
import MediaQuery from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { isSameYear, parseISO } from 'date-fns';
import { CdnIcon } from '@shared/ui/CdnIcon';
import { getProgressLevel } from '@features/price-graph';
import { Money } from '../../../../../../Money/components/Money';
import { useTheme } from '../../../../../../theme';
import DropdownAdapter from '../DropdownAdapter/DropdownAdapter';
import { MOBILE_MIN_WIDTH, TABLET_MIN_WIDTH, format } from '../../../../../../utils';
const MonthsList = ({ months, selectedMonth, onChange }) => {
    const { t } = useTranslation('PriceGraph');
    const theme = useTheme('Features').PriceGraph.MonthsListStyles;
    const [isOpen, setVisibility] = React.useState(false), currentMonth = new Date(selectedMonth);
    const isOnChange = (dateISO) => {
        setVisibility(false);
        onChange(dateISO);
    };
    const minPrice = {
        amount: months[0].minPrice ? months[0].minPrice.amount : 0,
        currency: months[0].minPrice ? months[0].minPrice.currency : null
    };
    const maxPrice = {
        amount: 0,
        currency: months[0].minPrice ? months[0].minPrice.currency : null
    };
    const firstMonthYear = months[0].dateISO;
    months.map(month => {
        if (month.minPrice) {
            if (month.minPrice.amount < minPrice.amount) {
                minPrice.amount = month.minPrice.amount;
            }
            if (month.minPrice.amount > maxPrice.amount) {
                maxPrice.amount = month.minPrice.amount;
            }
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: theme.header },
            React.createElement("div", { className: theme.currentMonth, onClick: () => setVisibility(!isOpen) },
                React.createElement("span", { className: theme.currentMonth__monthName }, format(currentMonth, 'LLLL')),
                React.createElement("span", { className: theme.currentMonth__year }, currentMonth.getFullYear()),
                React.createElement(CdnIcon, { icon: 'Arrow/Drop_up', className: classnames(theme.arrow_icon, { [theme.arrow_icon__open]: isOpen }) })),
            React.createElement("div", { className: theme.info_details },
                React.createElement(CdnIcon, { icon: 'Info/Details' }),
                React.createElement(MediaQuery, { minWidth: MOBILE_MIN_WIDTH }, t('Price is for all passengers, one way')),
                React.createElement(MediaQuery, { maxWidth: MOBILE_MIN_WIDTH }, t(`Estimated prices for one person, one way`)))),
        React.createElement(DropdownAdapter, { isOpen: isOpen, onClose: () => setVisibility(false) },
            React.createElement(MediaQuery, { maxWidth: TABLET_MIN_WIDTH },
                React.createElement("div", { className: theme.mobileHeader }, t('Select month'))),
            React.createElement("div", { className: theme.monthList }, months.map((month, index) => {
                return (React.createElement("div", { key: index, className: classnames(theme.month, {
                        [theme.month_min]: month.minPrice && month.minPrice.amount === minPrice.amount,
                        [theme.month_max]: month.minPrice && month.minPrice.amount === maxPrice.amount,
                        [theme.month__price__month_min]: month.minPrice && month.minPrice.amount === minPrice.amount,
                        [theme.month__price__month_max]: month.minPrice && month.minPrice.amount !== minPrice.amount
                    }), onClick: () => isOnChange(month.dateISO) },
                    React.createElement("div", { className: theme.month__name }, format(new Date(month.dateISO), !isSameYear(parseISO(firstMonthYear), parseISO(month.dateISO))
                        ? 'LLLL yyyy'
                        : 'LLLL')),
                    month.minPrice && (React.createElement(Money, { moneyClassName: theme.month__price, money: month.minPrice, showCurrencyBeforeAmount: true })),
                    React.createElement("div", { className: theme.bar },
                        React.createElement("div", { className: theme.progress, style: {
                                width: `${getProgressLevel(month.minPrice ? month.minPrice.amount : 0, maxPrice.amount)}%`
                            } }))));
            })))));
};
export default MonthsList;
